import {Button, DatePicker, Form, Input, Select, Space} from "antd";
import {useTranslation} from "react-i18next";
import {useDataGrid} from "../../../core/components/data-grid/DataGridContext";
import {useRef} from "react";

export default function LogFilter()
{
    const {t} = useTranslation();
    const {onFilterPageSort} = useDataGrid();
    const formRef = useRef();

    const reset = () => {
        formRef.current.resetFields();
        onFilterPageSort({
            filter: {}
        })
    }

    const filter = (form) => {
        const filterData = {
            ...form,
            dateFrom: form.dateFrom?.toISOString(),
            dateTo: form.dateTo?.toISOString()
        };
        onFilterPageSort({
            filter: filterData
        })
    }

    const logNameOptions = [
        { value: 'Study', label: t('Study') },
        { value: 'Exception', label: t('Exception') },
        { value: 'UserActivity', label: t('User Activity') },
    ];

    return (
        <>
            <Form
                ref={formRef}
                onFinish={filter}
                layout={'vertical'}
            >
                <Space style={{marginBottom: 16}}>
                    <Button type={'primary'} size={'small'} htmlType="submit">{t('Search')}</Button>
                    <Button size={'small'} onClick={reset}>{t('Reset')}</Button>
                </Space>
                <Form.Item
                    label={t('Log Name')}
                    name={'logName'}
                >
                    <Select 
                        allowClear 
                        options={logNameOptions} 
                        placeholder={t('Select log name')}
                    />
                </Form.Item>
                <Form.Item
                    label={t('Log Type')}
                    name={'logType'}
                >
                    <Input placeholder={t('Search by type')} />
                </Form.Item>
                <Form.Item
                    label={t('User')}
                    name={'userId'}
                >
                    <Input placeholder={t('Search by user')} />
                </Form.Item>
                <Form.Item
                    label={t('Primary Key')}
                    name={'primaryKey'}
                >
                    <Input placeholder={t('Search by primary key')} />
                </Form.Item>
                <Form.Item
                    label={t('Date From')}
                    name={'dateFrom'}
                >
                    <DatePicker style={{width: '100%'}} />
                </Form.Item>
                <Form.Item
                    label={t('Date To')}
                    name={'dateTo'}
                >
                    <DatePicker style={{width: '100%'}} />
                </Form.Item>
            </Form>
        </>
    )
}
